// resources/js/lib/bugsnag.js
import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'
import React from 'react'
import { releaseStageConfig } from './bugsnag-config'

// Check for frontend API key
const frontendApiKey = import.meta.env.MIX_BUGSNAG_API_KEY
export const appVersion = import.meta.env.MIX_APP_VERSION || '1.0.0'

if (!frontendApiKey || frontendApiKey === 'REPLACE_WITH_FRONTEND_API_KEY') {
    console.warn(
        'Bugsnag frontend API key not configured. Please set MIX_BUGSNAG_API_KEY in .env file',
    )
}

// Initialize Bugsnag with configuration
const bugsnagClient = Bugsnag.start({
    apiKey: frontendApiKey || 'dummy-key-for-development',
    plugins: [new BugsnagPluginReact(React)],
    appVersion,
    ...releaseStageConfig(import.meta.env.MIX_APP_ENV),
    collectUserIp: false,
    enabledBreadcrumbTypes: ['error', 'log', 'user', 'state', 'navigation'],
    onError: (event) => {
        // Add user context if available
        const user = window.userStore?.user
        if (user?.id) {
            event.setUser(user.id.toString(), user.email, user.name)
        }

        // Add additional context
        event.addMetadata('app', {
            url: window.location.href,
            userAgent: navigator.userAgent,
            timestamp: new Date().toISOString(),
        })

        return true
    },
})

// Create the ErrorBoundary component
export const ErrorBoundary = bugsnagClient.getPlugin('react').createErrorBoundary()

export default bugsnagClient
